import { msg } from '../messages'
import * as Util from '../util'

const PIS_PATTERN = '^[0-9]{11}$'
const PIS_PESOS: number[] = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

function pisRule(value: string): string {
  if (!isValid(value)) {
    return msg('pisInvalid', value)
  }
  return null
}

function hasCorrectPattern(value: string) {
  return new RegExp(PIS_PATTERN).test(value)
}

function calculaDigVerificador(value: string) {
  let dig = 0
  for (let i = 0; i < value.length; ++i) {
    dig += (value.charCodeAt(i) - 48) * PIS_PESOS[i]
  }
  dig = dig % 11
  return dig <= 1 ? 0 : 11 - dig
}

function isValid(value: string): boolean {
  if (Util.isEmpty(value)) {
    return true
  }
  if (!hasCorrectPattern(value) || verificaPisIgualZero(value)) {
    return false
  }
  const size = value.length
  const digitoVerificadorExperado = value.substr(size - 1, 1)
  const digitoVerificador = calculaDigVerificador(value.substr(0, 10))
  return digitoVerificador === +digitoVerificadorExperado
}

function verificaPisIgualZero(pisValue) {
  if (pisValue === '00000000000') {
    return true
  }
  return false
}

export const pis = [pisRule]
